import { LanguageSupportUtil } from './language_support_util';

const roadblockMessageName = 'mobile_roadblock';

const onRoadblockedClick = (messagingChannel, event, currentUser, afterRoadblock, options) => {
  const returnToUrl = options && options.returnToUrl ? options.returnToUrl : window.location.pathname + window.location.search;
  const atRef = options && options.atRef ? options.atRef : undefined;
  const openInNewTab = !!(options && options.openInNewTab);

  messagingChannel.publish(roadblockMessageName, {
    event,
    currentUser,
    atRef,
    afterRoadblock,
    returnToUrl,
    openInNewTab
  });
};

const buildSignupUrl = (href, atRef, languageRegionCode) => {
  const ref = atRef ? `ref=${atRef}&` : '';
  const returnTo = `returnTo=${encodeURIComponent(href)}`;
  return LanguageSupportUtil.wrapUrlSafe(`/signup?${ref}${returnTo}`, languageRegionCode);
};

const buildNonRoadblockedUrl = (href, atRef, languageRegionCode) => {
  const ref = atRef ? `${href.indexOf('?') === -1 ? '?' : '&'}ref=${atRef}` : '';
  return LanguageSupportUtil.wrapUrlSafe(`${href}${ref}`, languageRegionCode);
};

export { roadblockMessageName, onRoadblockedClick, buildSignupUrl, buildNonRoadblockedUrl };
